module.exports = __webpack_public_path__ + "img/a1.4dc585d4.png";